/**
 * Entry point for the ClarCV React application.
 * 
 * This file initializes the React application and renders the main App component
 * into the DOM. It uses React 18's createRoot API for better performance.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/**
 * Create React root and render the application.
 * Uses React 18's createRoot API for concurrent features.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
